import {styled} from "@cirrus/ui-kit/src"

export const StyledWrapper = styled("div")({
  color: 'rgb(51, 51, 51)',
  borderColor: 'rgb(0, 85, 176)',
  backgroundColor: 'rgb(236, 248, 255)',
  padding: '0.5rem 1.6rem',
  fontSize: '1.3rem',
  fontWeight: 'bold',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '4px',
})

export const StyledTitle = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  fontWeight: "bold",
})

export const StyledTitleText = styled("div")({
  padding: "8px 0",
  display: "flex",

  "& .MuiSvgIcon-root": {
    color: "rgb(0, 85, 176)",
    width: "22px",
    height: "22px",
    marginRight: "16px"
  }
})

export const StyledClosedText = styled("div")({
  color: "rgb(0, 85, 176)",
  cursor: "pointer",
  padding: "8px 0"
})

export const StyledReminderText = styled("div")({
  fontWeight: 'normal',
  paddingLeft: '38px',
  paddingBottom: '8px'
})